import React, { useState } from "react";
import { CreateJobPost } from "../components/recruiter/createNew";
import { VscTriangleRight } from "react-icons/vsc";
import graph from "../assests/graph.png";
import { IoMdCloseCircleOutline } from "react-icons/io";

const Discover = () => {
  // State to toggle video visibility
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const handleCloseVideo = () => {
    setIsVideoVisible(false);
  };

  // Handle the click event to show the iframe
  const handleViewDemoClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setIsVideoVisible(true); // Show the video
  };

  const URL = window.location.href;

  return (
    <div className="w-[93%] md:w-[95%]  mx-auto">
      {!URL.includes("naukritube") && (
        <div className="bg-[#151515] text-white  md:px-20 px-5 lg:px-20 md:py-14 py-10 lg:py-14 justify-between relative rounded-xl mt-5 flex md:flex-row lg:flex-row flex-col md:gap-y-0 lg:gap-y-0 gap-y-5 md:h-[21%] h-fit">
          <div style={{ wordBreak: "break-word" }}>
            <h1 className="text-white md:text-2xl lg:text-2xl text-sm ">
              Discover how Reaidy.io can transform your experience.
            </h1>
            <p className="text-gray-500 mt-2 md:text-2xl lg:text-2xl text-sm ">
              -watch our demo video here!
            </p>
          </div>
          <img
            src={graph}
            alt="graph"
            className="m-0 absolute bottom-10 md:bottom-0 lg:bottom-0 p-0 md:left-[60%]  lg:left-[60%]  left-[70%] md:h-28 md:w-32 lg:h-28 lg:w-32 h-20 w-20"
          />

          {/* View Demo Button */}
          <a
            href="#"
            onClick={handleViewDemoClick}
            className="flex gap-x-2 items-center my-auto !w-fit lg:max-h-10 md:max-h-10 h-10 bg-primary rounded-xl px-5"
          >
            <div className="bg-white text-base text-primary h-6 w-6 rounded-full relative p-1 ">
              <VscTriangleRight className="absolute left-1/4 top-1 " />
            </div>
            <p>View Demo</p>
          </a>
        </div>
      )}
      {/* /* Conditionally Render the Video Iframe */}
      {isVideoVisible && (
        <div
          // onClick={() => setIsVideoVisible(false)}
          className="fixed w-screen h-[105vh] z-[51] top-0 left-0 backdrop-filter backdrop-blur-sm bg-black overflow-hidden bg-opacity-40 "
        >
          <div className=" mt-36 tc1:mt-36 tc2:mt-48 tc3:mt-28 tc4:mt-48 tc5:mt-52 tc6:mt-64 tc7:mt-72 tc8:mt-16  lg:mt-72 tc12:mt-64 tc11:mt-48 md:mt-48 tc13:mt-54 ">
            <div
              className="relative bg-white w-[100%] h-[27rem] p-5 flex justify-center rounded-2xl "
              style={{
                maxWidth: "600px",
                margin: "20px auto",
                paddingTop: "2.5rem",
              }}
            >
              <IoMdCloseCircleOutline
                onClick={handleCloseVideo}
                className="absolute top-2 right-2 text-primary cursor-pointer"
                size={24}
              />
              <iframe
                width="90%"
                height="360"
                src="https://www.youtube.com/embed/cooSWzGkTzk?si=owonobHyFTEg-PZY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
      <h1 className="text-orange-500 text-3xl mt-10 gil-med">
        Services we offer
      </h1>
      <div className="pb-[30px]">
        <CreateJobPost />
      </div>
    </div>
  );
};

export default Discover;
